<template>
  <el-dialog
      title="添加黑名单"
      :visible="dialogVisible"
      width="650px"
      @close="dialogVisible = false"
      :close-on-click-modal="false"
      center
  >
    <el-form :model="formData" ref="refForm" label-width="90px">
      <el-form-item
          label="应用包名"
          prop="apkPackage"
          :rules="[{ required: true, message: '应用包名不能为空'}]"
      >
        <el-input
            :rows="6"
            type="textarea"
            class="w400"
            v-model="formData.apkPackage" placeholder="请输入应用包名"></el-input>
      </el-form-item>
      <div class="margin-l90 fontWeight">支持批量粘贴，包名以分行隔开</div>
      <div class="margin-l90 fontWeight">一次最多只能添加25个包名</div>
    </el-form>
    <div slot="footer">
      <el-button size="medium" type="primary" @click="onSubmit()">保存</el-button>
      <el-button size="medium" type="info" @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  data() {
    const numberRule = (rule, value, callback) => {
      if (Number(value) >= this.formData.expireDay) {
        if (Number.isInteger(Number(value)) && Number(value) >= 0) {
          if (Number(value) <= 180) {
            callback()
          } else {
            callback(new Error('不可大于180'))
          }
        } else {
          callback(new Error('请输入大于零的正整数'))
        }
      } else {
        callback(new Error('不能小于0'))
      }
    }
    return {
      numberRule: numberRule,
      //显示dialog
      dialogVisible: false,
      //数据
      formData: {
        apkPackage: '',
      }
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
      this.formData.apkPackage = ''
    },
    //提交
    onSubmit() {
      this.$refs['refForm'].validate((valid) => {
        if (valid) {
          this.$apis.blackServer.addBlack({
            apkPackage: this.formData.apkPackage,
          }).then(res => {
            if (res['code'] == 0) {
              this.dialogVisible = false;
              if (res.data && res.data.filterApkPackageList && res.data.filterApkPackageList.length) {
                const str = res.data.filterApkPackageList.join('、')
                this.$confirm(`包名${str}添加失败`, '添加失败', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  center: true
                })
              } else {
                this.$message.success('添加成功')
              }
              this.$emit("refresh");
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
